import { Tabs, TabsProps } from "antd";
import { List } from "@refinedev/antd";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { LawyerManagementShow } from "./Lawyer-Management-Show/Lawyer-Management-Show";
import { LawyerManagementDocsList } from "./LawyerManagementDocsList";

export function LawyerManagementPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const tabKey = searchParams.get("tab") || "content";

  const onChange = (key: string) => {
    navigate(
      { search: createSearchParams({ tab: key }).toString() },
      { replace: true }
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "content",
      label: "Контент",
      children: <LawyerManagementShow />,
    },
    {
      key: "docs",
      label: "Документы",
      children: <LawyerManagementDocsList />,
    },
  ];

  return (
    <List
      title="Руководство юриста"
      resource={"lawyer-management"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
    >
      <Tabs items={items} onChange={onChange} activeKey={tabKey} />
    </List>
  );
}
